declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    dataLayer: any[];
    // eslint-disable-next-line no-unused-vars
    gtag: (...args: any[]) => void;
  }
}

class Analytics {
  private enabled: boolean;

  constructor(measurementId: string | undefined) {
    this.enabled = !!measurementId;

    if (!this.enabled) {
      return;
    }

    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params,func-names
    window.gtag = function () { window.dataLayer.push(arguments); };

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    script.onload = () => {
      window.gtag('js', new Date());
      window.gtag('config', measurementId as string, { send_page_view: true });
    };
    document.head.appendChild(script);
  }

  // eslint-disable-next-line class-methods-use-this
  logEvent(name: string, parameters: any) {
    if (!this.enabled) return;

    window.gtag('event', name, {
      site: 'patient-booking',
      ...parameters,
    });

    if (process.env.REACT_APP_ENVIRONMENT === 'development' || process.env.REACT_APP_ENVIRONMENT === 'local') {
      // eslint-disable-next-line no-console
      console.log('Event Tracking: ', name, {
        site: 'website-booking',
        ...parameters,
      });
    }
  }

  logPageViewEvent(pageName: string, parameters: any) {
    this.logEvent('vpc_page_view', {
      page_name: pageName,
      ...parameters,
    });
  }

  trackVpcStartBooking(params: any) {
    this.logEvent('vpc_start_booking', params);
  }

  trackVpcCalendarOpen(params: any) {
    this.logEvent('vpc_calendar_open', params);
  }

  trackVpcTimeSelected(params: any) {
    this.logEvent('vpc_time_selected', params);
  }

  trackVpcFormStart(params: any) {
    this.logEvent('vpc_form_start', params);
  }

  trackVpcFormError(params: any) {
    this.logEvent('vpc_form_error', params);
  }

  trackVpcFormSubmit(params: any) {
    this.logEvent('vpc_form_submit', params);
  }

  trackVpcBookingSuccess(params: any) {
    this.logEvent('vpc_booking_success', params);
  }
}

const analytics = new Analytics(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID);
export default analytics;
